export default {
  namespaced: true,
  state: {
    groups: [],
  },
  getters: {
    groups: state => state.groups,
    groupsCount: state => state.groups.length,
  },
  actions: {
    // none yet
  },
  mutations: {
    setGroups(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.groups = data;
    },
    clearGroups(state) {
      // eslint-disable-next-line no-param-reassign
      state.groups = [];
    },
  },
};
